export enum PaymentType {
    _UNDEF,
    WithCard = 1,
    CollectPoints
}
